<template>
  <!-- 中央登录主体 -->
  <div class="login-container" v-loading.fullscreen.lock="logining">
    <div class="login-icon">
      <img src="@/assets/logo/florina-2021-white.png" alt="florina-logo">
    </div>
    <el-form :model="loginForm" :rules="rules" ref="loginForm" class="demo-ruleForm">
      <el-form-item prop="username">
        <el-input v-model.trim="loginForm.username" type="text" :class="[accountRequired?'f_required':'']" class="input-box" clearable :placeholder="accountPlaceholder"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model.trim="loginForm.password" :type="isPasswordShow?'':'password'" :class="[passwordRequired?'f_required':'']" class="input-box" clearable @keyup.enter.native="submit('loginForm')"  :placeholder="passwordPlaceholder"></el-input>
        <span class="eye-password" @click="showPassword" >
          <i class="el-icon-view " :class="[isPasswordShow?'eye-open':'eye-close']"></i>
        </span>
      </el-form-item>
      <el-form-item>
        <div class="submit-btn" @click="submit('loginForm')">
          {{$t('login.login')}}
          <!-- <span class="btn-name">{{$t('login.login')}}</span> -->
          <!-- <i class="el-icon-right"></i> -->
        </div>
      </el-form-item>
      <!-- 隐藏登录错误的提示 -->
      <!-- <el-form-item v-if="errorText != ''">
        <div class="text-danger login-error">{{errorText}}</div>
      </el-form-item> -->
    </el-form>
  </div>
</template>
<script>
import { mapMutations, mapActions } from 'vuex'
import qs from 'qs'
import { setToken } from '@/utils/auth'
export default {
  name:'normallogin',
  data(){
    var checkAccount = (rule, value, callback) => {
      if (!value) {
        this.accountRequired = true;
        this.accountPlaceholder = '请输入您的账号';
        return callback(new Error('请输入您的账号'));
      }else{
        this.accountPlaceholder = '您的账号';
        this.accountRequired = false;
        callback()
      }
    };
    var checkPassword = (rule, value, callback) => {
      if (!value) {
        this.passwordRequired = true;
        this.passwordPlaceholder = '请输入您的密码';
        return callback(new Error('请输入您的密码'));
      }else{
        this.passwordPlaceholder = '您的密码';
        this.passwordRequired = false;
        callback()
      }
    };
    return {
      logining:false,
      loginForm:{
        username:'',
        password:''
      },
      isPasswordShow:false,
      accountRequired:false,
      passwordRequired:false,
      accountPlaceholder:'您的账号',
      passwordPlaceholder:'您的密码',
      rules: {
        username: [
          { validator:checkAccount, trigger: 'blur' },
        ],
        password: [
          { validator:checkPassword, trigger: ['blur','change'] }
        ],
      },
      errorText: ''
    }
  },
  created(){
    // if(this.$route.query.errorText){
    //   this.errorText = this.$route.query.errorText
    // }
  },
  methods:{
    ...mapActions({
      login:'user/login'
    }),
    submit(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.logining = true;
          this.login(this.loginForm).then(accessToken=>{
            if(accessToken){
              setToken(accessToken)
              this.$router.push('/')
              this.logining = false;
            }else{
              this.$message.error('登录失败!');
              this.logining = false;
            }
          }).catch(err => {
            this.logining = false;
            this.$message.error(`登录失败,请稍后重试!=>${err.data.message}`);
            console.log('login error',err.data.status)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    showPassword(){
      this.isPasswordShow = !this.isPasswordShow
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/style/custom-variables.scss';
.login-container{
  position: absolute;
  top: 50%;
  left: 50%;
  width: 382px;
  margin: 0 auto;
  transform: translateX(-50%) translateY(-50%);
  z-index: 3;
  color: #ffffff;
  .login-icon{
    width: 100%;
    margin-bottom: 84px;
    text-align: center;
    img{
      max-width: 190px;
      transition: all 0.3s linear;
    }
    &:hover img{
      transform: translateY(-10px);
    }
  }
  .eye-password{
    position: absolute;
    top: 0;
    right: 30px;
    font-size: 16px;
    color: #bebebe;
    cursor: pointer;
  }
  .eye-close{
    &::after{
      content: '';
      width: 2px;
      height: 17px;
      transform: rotateZ(-45deg);
      background-color: #bebebe;
      position: absolute;
      top: 10px;
      left: 7px;
      opacity: 1;
      z-index: 2;
    }
  }
  .eye-open{
    color: $theme_color;
    &::after{
      content: '';
      opacity: 0;
    }
  }
  .submit-btn{
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    font-size: 14px;
    color: #333;
    background-color: $theme_color;
    text-align: center;
    font-weight: 500;
    // display: flex;
    // justify-content: space-between;
    cursor: pointer;
    .el-icon-right{
      font-size: 22px;
      line-height: 40px;
      font-weight: 600;
    }
    &:hover .el-icon-right{
      animation: moveToRight .4s linear infinite alternate;
      // transform: translateX(10px)
    }
  }
  .login-error{
    font-size: 14px;
    line-height: 20px;
    text-align: left;
  }
}
</style>
<style lang="scss">
@import '@/style/custom-variables.scss';
.login-container{
  .input-box{
    border-radius: 0px;
    .el-input__inner{
      height: 42px;
      line-height: 42px;
      border-radius: 0px;
      background: rgba(255,255,255,0.3);
      border: none;
      color: $theme_color;
      &:focus{
        background: rgba(255,255,255,1);
        color: #333;
      }
    }
  }
  .el-form-item{
    margin-bottom: 24px;
  }
  .f_required{
    .el-input__inner{
      background: rgba(255,255,255,1);
      color: #333;
      border:1px dashed $border-danger;
    }
  }
}
</style>



